// extracted by mini-css-extract-plugin
module.exports = {"gender":"sex_gender__362sA","genderButton":"sex_genderButton__Ojnar"};